var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJumpStart({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 4000 5000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M760 4160 l0 -400 -113 0 c-207 0 -338 -51 -467 -180 -87 -86 -131 -163 -160 -276 -19 -75 -20 -114 -20 -1144 0 -1030 1 -1069 20 -1144 29 -113 73 -190 160 -276 86 -87 163 -131 276 -160 76 -20 118 -20 2104 -20 1986 0 2028 0 2104 20 113 29 190 73 276 160 87 86 131 163 160 276 19 75 20 114 20 1144 0 1030 -1 1069 -20 1144 -29 113 -73 190 -160 276 -129 129 -260 180 -467 180 l-113 0 0 400 0 400 -600 0 -600 0 0 -400 0 -400 -600 0 -600 0 0 400 0 400 -600 0 -600 0 0 -400z m800 -200 l0 -200 -200 0 -200 0 0 200 0 200 200 0 200 0 0 -200z m2400 0 l0 -200 -200 0 -200 0 0 200 0 200 200 0 200 0 0 -200z m663 -629 c21 -13 50 -42 65 -64 l27 -41 0 -1066 0 -1066 -27 -41 c-15 -22 -44 -51 -65 -64 l-38 -24 -2026 0 -2025 0 -41 27 c-22 15 -51 44 -64 65 l-24 38 -3 1043 c-2 718 1 1056 8 1083 13 48 76 115 122 128 21 6 793 9 2043 8 l2010 -2 38 -24z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1160 2760 l0 -200 -200 0 -200 0 0 -200 0 -200 200 0 200 0 0 -200 0 -200 200 0 200 0 0 200 0 200 200 0 200 0 0 200 0 200 -200 0 -200 0 0 200 0 200 -200 0 -200 0 0 -200z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3160 2360 l0 -200 600 0 600 0 0 200 0 200 -600 0 -600 0 0 -200z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJumpStart);
export default __webpack_public_path__ + "static/media/jump-start.597378180856f76911b286d9845321ee.svg";
export { ForwardRef as ReactComponent };